<template>
  <div
    v-if="shouldRenderConfig"
    :class="[
      getClassName,
      isStatus ? '' : valid ? '' : getClassName + 'Invalid'
    ]"
  >
    <div :class="getClassName + 'Label'">
      {{ label }}
    </div>
    <div :class="getClassName + 'Desc'">
      <div v-if="!isStatus" :class="getClassName + 'Header'">
        <div :class="getClassName + 'Name'">
          {{ name }}
        </div>
        <span :class="getClassName + 'Icon'"></span>
      </div>
      <div v-if="!isStatus" :class="getClassName + 'Message'">
        {{ message }}
      </div>
      <div v-if="isStatus" :class="getClassName + 'Message'">
        <div v-for="(item, index) in message" :key="index">
          <span class="matrix_informationLabel">{{ index }} {{ item }}</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  computed: {
    isStatus: function () {
      return this.propsData.isStatus ? this.propsData.isStatus : false;
    },
    valid: function () {
      return this.propsData.valid;
    },
    label: function () {
      return this.propsData.label + ":";
    },
    message: function () {
      return this.propsData.message;
    },
    name: function () {
      return this.propsData.name;
    }
  },
  props: ["propsData"]
};
</script>
